<template>
  <div :class="success ?  'PVerify' : 'PVerify__error' ">
    <div class="PVerify__header">
      <span>Result: Batch Get Patient Benefits (PVerify)</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="PVerify__body">
        <div v-if="outputObject.csvUrl"><a :href="outputObject?.csvUrl">CSV Report</a></div>
        <json-viewer
            :value="outputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="PVerify__body">
        {{ outputObject }}
      </div>
    </div>
    <div v-if="extend && !success">
      <div class="PVerify__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 'default-action-output',
  components: { JsonViewer },
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      if(!this.isValidJson) {
        return this.output;
      }
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output)
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
